<template>
  <div>
    <md-table v-if="$store.state.pageLoaded" class="small-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" title="Dodaj popust" v-on:click="editCreateDialogVisible = createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyDiscount))" v-if="$store.state.schema['price-label'].create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Popusti</h1>
        </div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head>Popust</md-table-head>
        <md-table-head>Opis</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.discounts.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))" v-if="!item.default">
        <md-table-cell>{{ item.discount }}%</md-table-cell>
        <md-table-cell>{{ item.description }}</md-table-cell>
        <md-table-cell class="t-align-center actions-cell">
          <md-button class="md-icon-button md-accent" title="Obriši" v-on:click="deleteDialog = true" v-if="$store.state.schema['price-label'].delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button v-on:click="editCreateDialogVisible = true" class="md-icon-button" title="Uredi" v-if="$store.state.schema['price-label'].update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje popusta"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" class="edit-form md-scrollbar">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('discount', $store.state.selectedObject)">
              <label>Popust</label>
              <md-input required type="text" v-model="$store.state.selectedObject.discount"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('description', $store.state.selectedObject)">
              <label>Opis</label>
              <md-input required type="text" v-model="$store.state.selectedObject.description"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('kind', $store.state.selectedObject)">
              <label>Tip</label>
              <md-select reqired v-model="$store.state.selectedObject.kind">
                <md-option value="discount">Popust</md-option>
                <md-option value="gratis">Gratis</md-option>
              </md-select>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="createOrUpdate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import ListingMixin from '../../../mixins/listing-mixin.js'
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'Discounts',
  mixins: [ListingMixin('discounts', 'popust'), FormatCurrency],
  data(){
    return {
      requiredFields: ['discount','description'],
      emptyDiscount: {
        default: false,
        kind: '',
        discount: '',
        description: '',
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Discounts.vue